
import React from 'react';
import { PatientNewFlowDeleteInsurancePolicyConfirmModalTemplate } from 'themes/application/facility-order-new-flow-insurance/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PatientNewFlowDeleteInsurancePolicyConfirmModalStore } from 'application/facility-order-new-flow-insurance/stores';

@setCurrentView((rootStore, componentProps) => new PatientNewFlowDeleteInsurancePolicyConfirmModalStore(rootStore, componentProps), 'patientNewFlowDeleteInsurancePolicyConfirmModalStore')
@observer
class PatientNewFlowDeleteInsurancePolicyConfirmModal extends React.Component {
    render() {
        return <PatientNewFlowDeleteInsurancePolicyConfirmModalTemplate {...this.props} />
    }
}

export default PatientNewFlowDeleteInsurancePolicyConfirmModal;
